<ul class="summary" v-if="cart">
  <li>
      <span class="label">{{ $t('shopping.quickcart.deliverycosts') }} </span>
      <span v-html="cart?.shipping_cost" class="subtotal"></span>
  </li>
  <li v-if="cart?.wrapping !== 'standard'" >
      <span class="label">{{ $t('shopping.basket.checkout.gift_wrapping') }} </span>
      <span v-html="cart?.wrapping_cost" class="subtotal"></span>
  </li>
  <li v-if="cart.discount_number">
    <span class="label">{{ $t('my_account.orders.discount') }}</span>
    <span class="subtotal">{{ cart.discount }}</span>
  </li>
  <li>
    <span class="label">
      <span class="highlight">{{ $t('shopping.quickcart.total') }}</span> ({{ $t('shopping.quickcart.incl') }})
    </span>
    <span class="highlight">{{ cart.total_price }}</span>
  </li>
</ul>
